
import { useProgressReportStore } from '@entities/progress-report'
import { useProgressReportsListApi } from '@entities/progress-report'
import { useKidRoutes } from '@entities/customer'
import { WsEvent } from '@shared/api'
import { useCustomerStore } from '@entities/customer'
import { useDisciplineStore } from '@entities/customer'
import { useActiveDisciplineInfoApi } from '@entities/customer'
import { onDisciplineReady } from '@entities/customer'

export const useListenEventProgressReport = (channel: any): void => {
  const customerStore = useCustomerStore()
  const disciplineStore = useDisciplineStore()
  const progressReportsStore = useProgressReportStore()

  const {
    isRouteProgressReports,
  } = useKidRoutes()

  onDisciplineReady(() => {
    if (customerStore.isActiveDisciplinePaid && !disciplineStore.isActivation) {
      channel.listen(WsEvent.ProgressReportCreated, async (): Promise<void> => {
        const disciplineId = disciplineStore.activeDiscipline?.id
        if (!disciplineId) return

        if (isRouteProgressReports.value) {
          const listMode = progressReportsStore.getListStatus(disciplineId) === 'ready' ? 'refresh' : 'enter'
          void useProgressReportsListApi().getProgressReportList(disciplineId, listMode)
        } else {
          progressReportsStore.setNewProgressReport(disciplineId, true)
          void useActiveDisciplineInfoApi({ disciplineId, mode: 'refresh' })
        }
      })
    }
  })
}
